<script>
const {
    rem: { parseStyle, rem }
} = window.FEGOUtils;
import { isPc } from './utils';
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
export default {
    name: 'custom-swiper',
    props: {
        tpl: {},
        slideSpace: Number,
        activeColor: String,
        inactiveColor: String,
        loop: Boolean,
        centeredSlides: Boolean,
        autoPlay: Boolean,
        autoPlayDelay: {
            type: Number,
            default: 3000
        },
    },
    data() {
        return {
            isPc: isPc()
        };
    },
    computed: {
        swiperOptions() {
            return {
                centeredSlides: this.centeredSlides,
                loop: this.loop,
                slideSpace: this.slideSpace,
                autoPlay: this.autoPlay,
                slides: this.slides,
                autoPlayDelay: this.autoPlayDelay
            };
        },
        cssProperties() {
            return {
                '--swiper-padding-left': this.isPc || this.centeredSlides ? 0 : '0.4rem',
                '--swiper-pagination-color': this.activeColor,
                '--swiper-pagination-bullet-inactive-color': this.inactiveColor
            };
        }
    },

    methods: {
        setStyle(tpl) {
            let { style } = tpl;
            return style && parseStyle(style);
        },
        swiperBodyStyle(tpl) {
            const {
                style: { width, height }
            } = tpl;
            return parseStyle({ width, height });
        },

        async initSwiper() {
            const { centeredSlides, slideSpace, loop, autoPlay, slides, autoPlayDelay } = this.swiperOptions;
            const $swiper = this.$refs['swiper'];
            this.swiper && this.swiper.destroy();
            this.swiper =
                slides.length &&
                $swiper &&
                new Swiper($swiper, {
                    spaceBetween: slideSpace,
                    centeredSlides,
                    loop,
                    autoplay: autoPlay && {
                        delay: autoPlayDelay || 3000, // 每隔3秒自动播放
                        disableOnInteraction: false // 被用户交互之后，会继续自动播放
                    },
                    modules: [Autoplay, Pagination],
                    slidesPerView: 'auto',
                    // dynamicBullets: true,
                    pagination: {
                        el: '.swiper-pagination'
                    }
                });
        }
    }
};
</script>
